export default {"src":"/_next/static/media/poc-cloud.a81a628a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};